module.exports = __webpack_public_path__ + "static/media/limit.55108c03.png";